// extracted by mini-css-extract-plugin
export default {"success-container":"Ekl55AjFB4vtitOsRU0L","successContainer":"Ekl55AjFB4vtitOsRU0L"};